'use client'

import {useEffect} from 'react'
import {observer} from 'mobx-react'
import {usePathname} from 'next/navigation'

import {useLayoutStore} from '@/src/shared/ui/layout'
import {checkRequirementUserRules} from '@/src/core/domain/entities/user'
import {getInjection} from '@runlab/di'
import {LayoutEvents} from '@/src/core/domain/events/layout.events'
import {ChangeProfileContainer} from '@/src/features/requirement-session-fields/ui/change-profile'

interface SessionRequirementsProps extends React.PropsWithChildren {
  profileForm: React.ReactNode
}

export const SessionRequirementsService = observer(({profileForm, children}: SessionRequirementsProps) => {
  const pathname = usePathname()
  const layoutStore = useLayoutStore()
  const eventBus = getInjection('IEventBus')

  useEffect(() => {
    if (layoutStore.data.session?.user) {
      if (!checkRequirementUserRules(layoutStore.data.session?.user)) {
        eventBus.publish(LayoutEvents.userNotHaveRequirementFields())
      }
    }
  }, [pathname, layoutStore.data.session?.user])

  return (
    <>
      <ChangeProfileContainer profileForm={profileForm}>{children}</ChangeProfileContainer>
    </>
  )
})
